import { Asterisk } from "lucide-react";

export default function Marquee({ items }) {
  const row = [...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-black/10 bg-surface py-8"
    >
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-editorial text-3xl italic text-bone md:text-5xl">
                  {item}
                </span>
                <Asterisk className="shrink-0 text-flame" size={28} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
